import React from 'react';
import { X, DollarSign } from 'lucide-react';
import GoogleServiceConnect from './GoogleServiceConnect';

interface BudgetModalProps {
  onClose: () => void;
}

export default function BudgetModal({ onClose }: BudgetModalProps) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-black/90 w-full max-w-md rounded-2xl border border-pink-500/20">
        <div className="p-4 border-b border-pink-500/20 flex justify-between items-center">
          <h3 className="text-xl font-bold text-white">Connect Budget Service</h3>
          <button onClick={onClose} className="text-white/60 hover:text-white">
            <X className="h-6 w-6" />
          </button>
        </div>
        
        <div className="p-6 space-y-6">
          <GoogleServiceConnect
            service="sheets"
            icon={DollarSign}
            title="Google Sheets"
            description="Connect Google Sheets to manage and track your budget"
          />
          
          <p className="text-sm text-white/60 text-center">
            By connecting a service, you agree to our{' '}
            <a href="/terms" className="text-pink-500 hover:underline">Terms of Service</a>
            {' '}and{' '}
            <a href="/privacy" className="text-pink-500 hover:underline">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  );
}